import { z } from 'zod';
/**
 * A UUID-shaped string that does not conform to the UUID standard.
 * NOTE: This is required to match our hand-jammed invalid UUIDs spread throughout our testing codebase.
 */
export const uuidish = z.string().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
//# sourceMappingURL=uuidish.js.map